/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { EntityTileDamageMeta } from "../map/map"
export let EntityTilesDamageDefaults: Partial<Record<string, number>> = contentCatalog.source.tiles.damageDefaults
export let EntityTileDamageSpecifics = contentCatalog.source.tiles.damageSpecifics as Partial<Record<string, EntityTileDamageMeta[]>>

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    EntityTilesDamageDefaults: catalog.source.tiles.damageDefaults,
    EntityTileDamageSpecifics: catalog.source.tiles.damageSpecifics as Partial<Record<string, EntityTileDamageMeta[]>>,
}), next => {
    EntityTilesDamageDefaults = next.EntityTilesDamageDefaults
    EntityTileDamageSpecifics = next.EntityTileDamageSpecifics
})
